import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase/firebase";

const functions = getFunctions(app);
const auth = getAuth(app);
const THERAPIST_HTTP_ENDPOINT =
  "https://us-central1-assistant-49bb1.cloudfunctions.net/therapistChatHttp";

export async function sendMessageToTherapist(userMessage) {
  const trimmedMessage = (userMessage || "").trim();
  if (!trimmedMessage) {
    throw new Error("userMessage must be a non-empty string.");
  }

  const currentUser = auth.currentUser;
  if (currentUser) {
    try {
      const idToken = await currentUser.getIdToken();
      const response = await fetch(THERAPIST_HTTP_ENDPOINT, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ userMessage: trimmedMessage }),
      });

      let payload;
      try {
        payload = await response.json();
      } catch (parseError) {
        const error = new Error(
          "Invalid JSON response from therapistChatHttp."
        );
        error.cause = parseError;
        error.status = response.status;
        throw error;
      }

      if (!response.ok) {
        const message =
          payload?.error?.message ||
          `therapistChatHttp failed with status ${response.status}.`;
        const error = new Error(message);
        error.status = response.status;
        error.response = payload;
        throw error;
      }

      if (typeof payload?.result === "undefined") {
        throw new Error("therapistChatHttp returned an unexpected payload.");
      }

      return payload.result;
    } catch (httpError) {
      console.warn(
        "therapistChat HTTP call failed, attempting callable fallback",
        httpError
      );
    }
  }

  const callable = httpsCallable(functions, "therapistChat");
  const response = await callable({ userMessage: trimmedMessage });
  return response.data;
}
